import classNames from "classnames/bind";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import styles from "./Colour.module.scss";

const cx = classNames.bind(styles);

type ColourProps = {
  selected: boolean;
  unavailable: boolean;
  value: string;
  swatch?: string;
  onClick: (value: string) => void;
};

export const Colour = ({
  selected,
  unavailable,
  value,
  swatch = "",
  onClick,
}: ColourProps) => {
  const inputId = `colourSelector_${value}`;

  return (
    <div className={styles.colour} data-jlds={true}>
      <input
        checked={selected}
        className={styles.colour__input}
        id={inputId}
        name="colourSelector"
        onChange={(e) => onClick(e.target.value)}
        type="radio"
        value={value}
      />
      <label
        className={cx(styles.colour__label, {
          colour__label__unavailable: unavailable,
          colour__label__selected: selected,
        })}
        htmlFor={inputId}
      >
        <span
          className={styles.colour__swatch}
          style={{
            backgroundImage: `url(${formatAmplienceImageURL(swatch)})`,
          }}
        />
        <span className={styles.colour__label__text}>{value}</span>
        {(unavailable || selected) && (
          <span className={styles.colour__properties}>
            {selected && " selected"}
            {unavailable && " currently unavailable"}
          </span>
        )}
      </label>
    </div>
  );
};
